export default function SignalBars({ strength, color = "emerald" }) {
  const activeClass = color === "magenta" ? "bg-brand-magenta" : "bg-emerald-400";
  return (
    <div className="flex items-end gap-[2px] h-4">
      {[1, 2, 3].map((bar) => (
        <div
          key={bar}
          style={{ height: `${bar * 33}%` }}
          className={`w-[4px] rounded-sm ${bar <= strength ? activeClass : "bg-brand-light/20"}`}
        />
      ))}
    </div>
  );
}
